const viewFormData = (formData) => {
    for (var key of formData.entries()) {
        console.log(key[0] + ' - ' + key[1])
    }
    return;
};
export default viewFormData;